<template>
  <div style="width: 100%">
    <v-container
        class="mc-main-container mt-12 mb-md-4 mb-lg-4 mb-xl-4 text-center text-body-2"
    >
      <div class="d-flex align-start justify-space-between">
        <!--<v-breadcrumbs class="justify-center" :items="links" />-->
        <UpdateStatus class="ma-1 text-left" />

        <div class="ma-1 text-center">
          Made by <a href="https://github.com/rodinf" target="_blank">@rodinf</a>
        </div>

        <div class="ma-1 text-right">
          <router-link to="/about/faq">FAQ</router-link>
          <span class="text--secondary">&nbsp;/</span>
          <br />
          <router-link to="/about/support">Сообщить об ошибке</router-link>
        </div>

      </div>
    </v-container>
  </div>
</template>

<script>
import UpdateStatus from "@/components/UpdateStatus";

export default {
  name: "FooterContacts",
  components: {
    UpdateStatus: UpdateStatus
  },
  data: () => ({
    links: [
        /*
      {
        text: 'О проекте',
        disabled: false,
        to: 'about',
      },
         */
      {
        text: 'Сообщить об ошибке',
        disabled: false,
        to: 'support',
      }
    ],
  }),
}
</script>

<style scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
